import React from "react";

export default function ProjectImageFileComponent(props) {
    return (
        <>
            {props.file && (
                <img
                    style={{
                        display: "block",
                        width: "100%",
                        maxWidth: props.contentWidth,
                        height: "auto",
                        margin: "0 auto",
                        borderRadius: 12,
                    }}
                    src={props.file.url}
                    alt={props.file.name || "Project resource"}
                />
            )}
        </>
    );
}
